import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';

import { Store } from '../../../common/model/Store';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { OrganizationFacade } from '../../../common/facade/OrganizationFacade';
import { TenantFacade } from '../../../common/facade/TenantFacade';

@Component({
    selector: 'app-stores',
    templateUrl: './stores.component.html',
    styleUrls: ['./stores.component.css']
})
export class StoresComponent implements OnInit {
    titleStores = res.Stores;
    lblDownload = res.Download;
    lblAddStores = res.AddStore;
    lblSearch = res.Search;
    lblName = res.Name;
    lblBrand = res.Brand;
    lblStoreType = res.StoreType;
    lblCountry = res.Country;
    lblActive = res.Active;
    lblParticipateQuantum = res.ParticipateQuantum;
    lblReasonForClosure = res.ReasonForClosure;
    lblReopeningDate = res.ReopeningDate;
    lblSelectAnOption = res.SelectAnOption;
    lblTodas = res.AllMayusA;
    lblTodos = res.AllMayusO;
    lblCancel = res.Cancel;
    lblContinue = res.Continue;
    lblOrganization = res.Organization;
    lblTenant = res.Tenant;
    lblMigradaNE = res.MigradaNE;
    lblReqPackage = res.ReqPackage;

    isSpanish = true;
    language = 0
    public organizationList = [];
    public tenantList = [];
    tenantId: Number = -1;
    organizationId = "";

    messagesTable: any = {
        emptyMessage: "",
        totalMessage: ""
    }

    loading = false;
    messageLoader = '';
    // alert
    alerts = [];
    alertsModal = [];
    rows: Store[];
    private _filteredData: Store[];
    permissionsList = [];
    _addStoreVisible = false;

    modal: BsModalRef;
    config = {
        keyboard: false,
        ignoreBackdropClick: true // si es false se cierra el modal dar clic fuera de el
    };

    messageTitleActive: string = '';
    messageActive: string = '';

    lsClosingReason: any[] = [];
    cmb_closingReason = -1
    txt_min_date = new Date();
    txt_reopeningDate: Date;

    active = false
    actionAux: number;
    storeAux: Store;


    constructor(
        @Inject(SESSION_STORAGE) private _storage: WebStorageService,
        private modalService: BsModalService,
        private _facade: StoreFacade,
        private _facadeCatalogDet: CatalogDetFacade,
        private _organizationFacade: OrganizationFacade,
        private _tenantFacade: TenantFacade,
        private _router: Router,
        private _excel: ExcelUtility,
        public strings: Strings,
        private _route: ActivatedRoute,
    ) {
        this._storage.set('moduleUrl', this._router.url);
    }

    ngOnInit() {
        this.isSpanish = this.strings.getLanguageIsSpanish();

        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = 'Total';

        if (!this.isSpanish) {
            this.language = 1
        }

        this.getAllStores()

        this.txt_min_date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        
        this.validatePermissions();
        this.tenantId = -1;
        this.organizationId = "";

        this._tenantFacade.GetAll().subscribe(result => {
            this.tenantList = [];
            if (result.completed) {
                this.tenantList = result.data;
            }
        });
    }

    getAllStores() {
        this.loading = true;
        this._facade.GetAll().subscribe(result => {
            if (result.completed) {
                this.rows = result.data;
                this._filteredData = result.data;
                this.getClosingReasonCatalog()

                this._route.queryParams.subscribe(params => {
                    if (params['tenantId'] !== undefined) {
                        this.tenantId = params['tenantId']
                        this.rows = this._filteredData.filter(item => {
                            return (item.tenantId == this.tenantId);
                        });
                    }
        
                    if (params['orgId'] !== undefined) {
                        this.organizationId = params['orgId'];
                        this.rows = this.rows.filter(item => {
                            return (item.organizationId == this.organizationId && Number(item.tenantId) == this.tenantId);
                        });
                    }
                });

                this.getOrganization();
            }
            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    getClosingReasonCatalog() {
        this.loading = true;
        this._facadeCatalogDet.Get(45, this.language).subscribe(result => {
            if (result.completed) {
                this.lsClosingReason = result.data;
                this.loading = false;
            }
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    // añadir alert
    addAlert(message: String, type: String) {
        this.alerts = [];
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // añadir alert
    addAlertModal(message: String, type: String) {
        this.alertsModal = [];
        this.alertsModal.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent) {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    updateFilter(event) {
        // get the value of the key pressed and make it lowercase
        const val = event.target.value.toLowerCase();

        // get the key names of each column in the dataset
        const keys = Object.keys(this._filteredData[0]);

        // assign filtered matches to the active datatable
        this.rows = this._filteredData.filter(function (item) {
            // iterate through each row's column data
            for (let i = 0; i < keys.length; i++) {
                if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });

        if (this.organizationId == "" && this.tenantId == -1) {
            this.rows = this.rows
        }
        else if (this.organizationId == "") {
            this.rows = this.rows.filter(item => {
                return (item.tenantId == this.tenantId);
            });
        }
        else {
            this.rows = this.rows.filter(item => {
                return (item.organizationId == this.organizationId && Number(item.tenantId) == this.tenantId);
            });
        }
    }

    onViewDetail(action: number, id: number) {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'action': action,
                'id': id,
                'tenantId': this.tenantId,
                'orgId': this.organizationId
            }
        };

        this._router.navigate(['/config/stores/detail'], navigationExtras).then((e) => { });
    }

    toggleVisibility(e, item) {
        // console.log(item);
        // console.log(e);
    }

    downloadLayout() {
        if (this.rows.length > 0) {
            const data: any = [];
            this.rows.forEach(row => {
                let info: any;
                if (this.isSpanish) {
                    info = {
                        'Id': row.storeCode,
                        [this.strings.GetText(res.Name)]: row.storeName,
                        [this.strings.GetText(res.Brand)]: row.storeTradeMark,
                        [this.strings.GetText(res.StoreType)]: row.storeType,
                        [this.strings.GetText(res.Country)]: row.country,
                        [this.strings.GetText(res.Active)]: row.active,
                        [this.strings.GetText(res.ParticipateQuantum)]: row.participateQuantum,
                        [this.strings.GetText(res.MigradaNE)]: row.migrateNS,
                        [this.strings.GetText(res.ReqPackage)]: row.packageReq,

                    };
                } else {
                    info = {
                        'Id': row.storeCode,
                        [this.strings.GetText(res.Name)]: row.storeName,
                        [this.strings.GetText(res.Brand)]: row.storeTradeMark,
                        [this.strings.GetText(res.StoreType)]: row.storeType,
                        [this.strings.GetText(res.Country)]: row.country,
                        [this.strings.GetText(res.Active)]: (row.active == false ? "FALSE " : "TRUE "),
                        [this.strings.GetText(res.ParticipateQuantum)]: (row.participateQuantum == false ? "FALSE " : "TRUE "),
                        [this.strings.GetText(res.MigradaNE)]: (row.migrateNS == false ? "FALSE " : "TRUE "),
                        [this.strings.GetText(res.ReqPackage)]: (row.packageReq == false ? "FALSE " : "TRUE "),

                    };

                }
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, 'data');
        } else {
            this.addAlert(this.strings.GetText(res.AlertSelectActivityFirst), 'danger');
        }
    }

    onChangeActive(store: Store, template: TemplateRef<any>, action: number) {
        this.storeAux = store
        this.actionAux = action
        this.active = false;
        this.alertsModal = []
        this.cmb_closingReason = -1
        this.txt_reopeningDate = null
        let classModal = 'gray modal-lg modal-primary';
        switch (action) {
            case 1:
                if (store.active) {
                    this.messageTitleActive = this.strings.GetText(res.ActivateStore);
                    this.messageActive = this.strings.GetText(res.StoreWillBeActivated).replace('{0}', store.storeName);
                }
                else {
                    this.messageTitleActive = this.strings.GetText(res.DesactivateStore);
                    this.messageActive = this.strings.GetText(res.AreYouSureToDeactivateStore).replace('{0}', store.storeName);
                    classModal = 'gray modal-lg modal-warning';
                    this.active = true;
                }
                break;

            case 2:
                if (store.participateQuantum) {
                    this.messageTitleActive = this.strings.GetText(res.ParticipateQuantum);
                    this.messageActive = this.strings.GetText(res.ParticipationQuantumWillBeActivated).replace('{0}', store.storeName);
                }
                else {
                    this.messageTitleActive = this.strings.GetText(res.RemoveParticipateQuantum);
                    this.messageActive = this.strings.GetText(res.AreyouSureToDisableQuantumEngagement).replace('{0}', store.storeName);
                    classModal = 'gray modal-lg modal-warning';
                }
                break;
            case 3:
                if (store.migrateNS) {
                    this.messageTitleActive = this.strings.GetText(res.MigradaNEModal);
                    this.messageActive = this.strings.GetText(res.AreyouSureToActivatedMigradaNE).replace('{0}', store.storeName);
                }
                else {
                    this.messageTitleActive = this.strings.GetText(res.MigradaNEModal);
                    this.messageActive = this.strings.GetText(res.AreyouSureToDisableMigradaNE).replace('{0}', store.storeName);
                    classModal = 'gray modal-lg modal-warning';
                }
                break;
            case 4:
                if (store.packageReq) {
                    this.messageTitleActive = this.strings.GetText(res.RequierePaqueteria);
                    this.messageActive = this.strings.GetText(res.AreyouSureToActivatedReqPaqueteria).replace('{0}', store.storeName);
                }
                else {
                    this.messageTitleActive = this.strings.GetText(res.RequierePaqueteria);
                    this.messageActive = this.strings.GetText(res.AreyouSureToDisableReqPaqueteria).replace('{0}', store.storeName);
                    classModal = 'gray modal-lg modal-warning';
                }
                break;
        }
        this.modal = this.modalService.show(
            template,
            Object.assign({}, { class: classModal }, this.config)
        );
    }

    onChangeReopeningDate(value) {
        this.txt_reopeningDate = value
    }

    onCloseModal() {
        switch (this.actionAux) {
            case 1:
                this.rows.find(x => x.storeId == this.storeAux.storeId).active = !this.storeAux.active
                break;
            case 2:
                this.rows.find(x => x.storeId == this.storeAux.storeId).participateQuantum = !this.storeAux.participateQuantum
                break;
            case 3:
                this.rows.find(x => x.storeId == this.storeAux.storeId).migrateNS = !this.storeAux.migrateNS
                break;
            case 4:
                this.rows.find(x => x.storeId == this.storeAux.storeId).packageReq = !this.storeAux.packageReq
                break;
        }
        this.modal.hide()
    }

    updateStore() {
        switch (this.actionAux) {
            case 1:
                if (this.storeAux.active) {
                    this.storeAux.catDetClosingReasonId = -1
                    this.storeAux.reopeningDate = null
                    this.storeAux.closingDate = null
                }
                else {
                    if (this.cmb_closingReason < 0) {
                        this.addAlertModal("<strong>" + this.strings.GetText(res.AlertSelectClosingReason) + "</strong>", "warning");
                        return;
                    }
                    if (this.txt_reopeningDate == null) {
                        this.addAlertModal("<strong>" + this.strings.GetText(res.AlertSelectReopeningDate) + "</strong>", "warning");
                        return;
                    }
                    this.storeAux.catDetClosingReasonId = this.cmb_closingReason
                    this.storeAux.reopeningDate = this.txt_reopeningDate
                    this.storeAux.closingDate = this.txt_min_date
                }
                break;
        }
        this.loading = true;
        this._facade.UpdateMasterData(this.storeAux).subscribe(result => {
            if (result.completed) {
                this.addAlert("<strong>" + this.strings.GetText(res.AlertStoreSuccessfullyUpdated) + "</strong>", "success");
                this.modal.hide();
            }
            else {
                this.addAlert("<strong>" + result.message + "</strong>", "danger");
                this.onCloseModal();
            }
            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    validatePermissions() {
        this.permissionsList = this._storage.get('permissions');
        this.permissionsList.forEach(element => {
            if (element.name === Permissions.GeneralAccess || element.name === Permissions.AdminStoreCreate) {
                this._addStoreVisible = true;
            }
        });
    }

    getOrganization() {
        this._organizationFacade.GetAll().subscribe(result => {
            this.organizationList = [];
            if (result.completed) {
                this.organizationList = result.data.filter(x => x.tenantId == Number(this.tenantId));
            }
        });
    }

    onTenantChange() {
        this.getOrganization();
        if (this.tenantId == -1) {
            this.organizationId = ""
            this.rows = this._filteredData
        }
        else {
            this.onOrganizationChange()
        }

    }

    onOrganizationChange() {
        if (this.organizationId == "") {
            this.rows = this._filteredData.filter(item => {
                return (item.tenantId == this.tenantId);
            });
        }
        else {
            this.rows = this._filteredData.filter(item => {
                return (item.organizationId == this.organizationId && Number(item.tenantId) == this.tenantId);
            });
        }
    }

}
